// Example starter JavaScript for disabling form submissions if there are invalid fields.
(function () {
	'use strict'
	// Fetch all the forms we want to apply custom Bootstrap validation styles to.
	const forms = document.querySelectorAll('.needs-validation');

	if (forms.length > 0) {
		[].forEach.call(forms, function(form) {
			[].forEach.call(form, function(element) {
				element.addEventListener('focusout', function (event) {
					if (element.checkValidity()) {
						element.classList.add('is-valid');
						element.classList.remove('is-invalid');
					} else {
						element.classList.add('is-invalid');
						element.classList.remove('is-valid');
					}
				}, false)
			});
		});

		// Loop over them and prevent submission.
		Array.prototype.slice.call(forms)
		.forEach(function (form) {
			form.addEventListener('submit', function (event) {
				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()
				}

				form.classList.add('was-validated')
			}, false)
		})
	}
})()
